import { render, staticRenderFns } from "./CompetitorStatsSummary.vue?vue&type=template&id=34ca44c7"
import script from "./CompetitorStatsSummary.vue?vue&type=script&lang=js"
export * from "./CompetitorStatsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports